import Swiper, {Autoplay} from "swiper";

Swiper.use([Autoplay])

export default class Usp {
    constructor() {
        this.usp();
    }

    usp() {
        if (document.querySelector('#usp')) {
            const swiper = new Swiper('#usp .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    }
                }
            });
        }
    }
}
